import React, { FC } from 'react'
import Select, { OptionsType, components, ActionMeta } from 'react-select'
import { ReactComponent as SearchIcon } from '../../assets/search.svg'
import { ReactComponent as CrossIcon } from '../../assets/cross.svg'
import { isArray } from 'lodash-es'

export type OptionType = { value: string; label: string }

interface Props {
  className?: string
  options: OptionsType<OptionType>
  defaultValue?: OptionType[] | OptionType
  onChange: (e: Array<OptionType> & OptionType, action: ActionMeta<OptionType>) => void
  placeholder?: string
  searchableLimit?: number
  noOptionsMessage?: string
  isMulti?: boolean
}

export const Search: FC<Props> = ({
  className = '',
  options,
  defaultValue,
  onChange,
  placeholder = 'Search...',
  searchableLimit = 5,
  noOptionsMessage = 'No results found',
  isMulti,
}) => {
  const enableFilterAction = !isArray(defaultValue) || defaultValue.length < searchableLimit

  return (
    <div className={`-multi-search ${className}`}>
      <Select
        onChange={onChange as any}
        className="accsel-container"
        classNamePrefix="accsel"
        value={defaultValue}
        isMulti={isMulti}
        options={options}
        noOptionsMessage={() => noOptionsMessage}
        placeholder={placeholder}
        isSearchable={enableFilterAction}
        hideSelectedOptions={true}
        closeMenuOnSelect={true}
        components={{
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          DropdownIndicator,
          MultiValueRemove,
          Menu: enableFilterAction ? Menu : () => null,
        }}
        // menuIsOpen
        styles={{
          // Removed, use react-select-manual-styles.css
          clearIndicator: () => ({}),
          container: () => ({}),
          control: () => ({}),
          dropdownIndicator: () => ({}),
          group: () => ({}),
          groupHeading: () => ({}),
          indicatorsContainer: () => ({}),
          indicatorSeparator: () => ({}),
          input: () => ({}),
          loadingIndicator: () => ({}),
          loadingMessage: () => ({}),
          menu: () => ({}),
          menuList: () => ({}),
          menuPortal: () => ({}),
          multiValue: () => ({}),
          multiValueLabel: () => ({}),
          multiValueRemove: () => ({}),
          noOptionsMessage: () => ({}),
          option: () => ({}),
          placeholder: () => ({}),
          singleValue: () => ({}),
          valueContainer: () => ({}),
        }}
      />
    </div>
  )
}

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator className="" {...props}>
      <SearchIcon className="" style={{ height: 24 }} />
    </components.DropdownIndicator>
  )
}

const MultiValueRemove = (props: any) => {
  return (
    <components.MultiValueRemove className="" {...props}>
      <CrossIcon className="" style={{ height: 18 }} />
    </components.MultiValueRemove>
  )
}

const Menu = (props: any) => {
  return <components.Menu {...props}>{props.children}</components.Menu>
}
